const EnvelopeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="13" viewBox="0 0 12 13" fill="none">
      <path
        d="M10.8 2H1.2C0.54 2 0.00599999 2.54 0.00599999 3.2L0 10.4C0 11.06 0.54 11.6 1.2 11.6H10.8C11.46 11.6 12 11.06 12 10.4V3.2C12 2.54 11.46 2 10.8 2ZM10.8 4.4L6 7.4L1.2 4.4V3.2L6 6.2L10.8 3.2V4.4Z"
        fill="#BDC2C5"
      />
    </svg>
  );
};

export default EnvelopeIcon;
